const learn = {
  header: 'Learn + Earn',
  header_title: 'Lessons',
  header_subtitle: 'Discover helpful information and get rewarded!',
};

export default learn;
